import {IContentInfo, IPreview, PreviewType} from '../types/types';

export function getBigPreview(content: IContentInfo) {
    const result = content.previews.filter((elem: IPreview) => {
        return elem.type === PreviewType.type2;
    });

    return result[0];
}
